export const getDeviceTypeByScreenSize = () => {
  const { innerWidth } = window;
  if (innerWidth < 768) {
    return "Mobile";
  }
  if (innerWidth < 1024) {
    return "Tablet";
  }
  return "Desktop";
};
